import React from 'react';
import {Row, Col} from 'react-bootstrap';
import {connect} from 'react-redux';
import {getQuizScore} from '../actions/ProAction';
import AnalysisChart from '../components/charts/AnalysisChart';
import '../styles/css/pro.analysis.css';
import {pageView} from '../util/tracking';
// import {Chart} from 'react-chartjs-2';

class Analysis extends React.Component{

  constructor(props){
    super(props);
    this.state={
      quizScore: null,
      // width: null,
      width: window.innerWidth/12,
      location: props.location.pathname
    };
    // this.resize = this.resize.bind(this);

  }

  // componentDidMount(){
  //   console.log("did mount");
  //   // let width = ReactDOM.findDOMNode(this).offsetWidth;
  //   // console.log(width);
  //   window.addEventListener('resize',this.resize)
  // }
  //
  // resize(){
  //   console.log("resized");
  //   // let width = ReactDOM.findDOMNode().offsetWidth;
  //   // console.log(width);
  //   console.log(window.innerWidth);
  // }

  componentWillMount(){
    if(this.props.quizScore === null){
      this.props.getQuizScore(this.props.courseId);
    }

    pageView();


    // console.log(window.innerWidth);
    // if(!this.state.width){
    //   console.log("called");
    //
    //   this.setState({
    //     // width: window.innerWidth/12,
    //     // location: this.props.location.pathname
    //   });
    // }

    // this.setState({width:'2600px'})
    // console.log(this.props.quizScore.length);
    // this.setState({windowWidth:})

    // Chart.pluginService.register({
      // afterDraw: function (chart, easing){
//https://stackoverflow.com/questions/37332593/chart-js-2-0-how-to-change-default-appearance-of-canvas-chart-elements
      // }
    // })

  }

  componentWillReceiveProps(nextProps){
    // let count = nextProps.quizScore[0].score.question_num.length;
    if(this.state.location !== nextProps.location.pathname){
      this.setState({location:nextProps.location.pathname})
    }

  //   this.setState({
  //     quizScore : nextProps.quizScore
  //   });
  //   let width = ReactDOM.findDOMNode(this).offsetWidth;
  //   console.log(width);
  }

  render(){
    let {quizScore} = this.props;

    return(
      <Row className="pro_row">
        <Col xs={12} md={10} mdOffset={1}>
          {quizScore?quizScore.map((set, index)=>(
            <AnalysisChart key={"chart_"+index} data={set} width={this.state.width}/>
          )):null}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps=(state)=>{
  return{
    quizScore: state.pro.quizScore,
    courseId: state.auth.courseId
  };
};

const mapDispatchToProps=(dispatch)=>{
  return{
    getQuizScore: (courseId)=>{
      dispatch(getQuizScore(courseId));
    }
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(Analysis);



// WEBPACK FOOTER //
// ./src/containers/Pro.Analysis.js